module.exports = "images/food_restaurant.1f1fe20351f677dd629169a8b70bbffb.png";